import { useMemo } from "react";
import { useGetTalentTimersQuery } from "./timerEndpoints";
import { Timer } from "../../kronos-kit";

export function useTalentTimers(talentID: number | undefined) {
  const timerQuery = useGetTalentTimersQuery(talentID ?? 0, {
    skip: (talentID ?? 0) <= 0,
  });
  const timerEntitiesMap = timerQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof timerQuery & {
      timers?: Timer[];
      timersMap?: { [id: number]: Timer };
    } = {
      ...timerQuery,
      timers: [],
      timersMap: {},
    };
    if (timerEntitiesMap) {
      const timers: Timer[] = [];
      const timersMap: { [id: number]: Timer } = {};

      for (const key in timerEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(timerEntitiesMap, key)) {
          const c = timerEntitiesMap[key];
          const timer = new Timer(c);
          timers.push(timer);
          timersMap[timer.id] = timer;
        }
      }
      ret.timers = timers;
      ret.timersMap = timersMap;
    }

    return ret;
  }, [timerEntitiesMap]);
}
